import React, {Fragment, useEffect} from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails, Backdrop, CircularProgress,
} from "@material-ui/core";
import { useTranslation, Trans } from "react-i18next";

//ファイル分割化
import {
  FlightModalApi,
  FlightModal,
  ConnectingFlightModal,
  HotelCheckInTimeModal,
  StaySelectModal,
  ScheduleDetailModal,
  NumberOfPeopleModal,
  LinkListModal,
  ComprehensiveOptionDetailsModal,
  AdditionalFlightModal
} from "./../../modal"

//scss
import "../../../scss/common.scss";
import "../../../scss/component.scss";

//ダイアログインポート
import {
  DialogCancel,
  DialogChange,
} from "./../../dialog"

// types
import {PlanSearch} from "../../../types/Search";

import {PlanSelectFormData, PlanSelectFromFlightType, PlanSelectFromHotelType} from "../../../types/planSelectForm";
import {planSelectScheduleList, scheduleListModalData} from "../../../types/planSelectConfirm";
import {IActivity} from "../../../types/Activity";
import {FReservationFlightEntity,FlightType} from "../../../types/Flight";

// lib
import {
  getFlightCodeLabel,
  getFlightCodeByLabel,
  getFlightTotalPrice,
  getFlightPeopleConfirmLabel, getFlightTime, getFlightNumberForDisplay, getAirLineLogo, getAirLineNameInJalGroup, getAirLineNameInAnaGroup, isConnectionFlight,
  getMaxAdditionalFlightSegments,
} from "../../../utils/flight";
import {dateFormat, dayAgo, inDateTimeRange, rangeDate} from "../../../utils/convert";
import {getPlanSelectSchedule} from "../../../utils/schedule";
import {
  getHotelAreaCode,
  getHotelTypeLabel,
  hotelCancelDisabled,
  hotelChangeDisabled,
  hotelRoomSearch
} from "../../../utils/hotel";
import DialogHotelCancel from "../../dialog/DialogHotelCancel";
import DialogAdditionalFlightCancel from "../../dialog/DialogAdditionalFlightCancel";
import {getBasicTotalPrice} from "../../../utils/price";
import {makeStyles} from "@material-ui/core/styles";
import {devLog} from "../../../utils/errors";
import {isOkinawaSaihakkenLabel} from "../../../utils/discount";
import {FReservationConnectionFlight, FReservationFlight} from "../../../types/FlightV2";
import {getFlightBookingClass, isConnection, lastCurrentFlight, getFlightClassLabel, createReserveFlightNumber} from "../../../utils/flightV2";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

type Props = {
  planSelectFormData: PlanSelectFormData,
  scheduleListData: scheduleListModalData,
  updatePlanSelectFormData(updatePlanData: PlanSelectFormData): void
  updateScheduleListData(scheduleListData: scheduleListModalData): void
}

/**
 * 旅程の確認・変更・追加 旅行日程セクション
 * @param planSelectFormData
 * @param updatePlanSelectFormData
 * @constructor
 */
const SectionSchedule: React.FC<Props> = ({
    planSelectFormData,
    updatePlanSelectFormData,
    scheduleListData,
    updateScheduleListData,
  }) => {
  const { t, i18n } = useTranslation();
  const classesForLoading = useStyles();
  const [isSectionScheduleLoading, setIsSectionScheduleLoading] = React.useState(false);
  //-------------------------------------------------
  //　モーダルの処理
  //-------------------------------------------------
  //モーダル初期表示ページを設定
  const [step, setStep] = React.useState(1);
  const stepHandle = (step: number) => {
    setStep(step)
  }

  // モーダルのステータスを追加する
  const [staySelectModal1, setStaySelectModal1] = React.useState(false);
  const [staySelectModal2, setStaySelectModal2] = React.useState(false);
  const [scheduleDetailModal, setScheduleDetailModal] = React.useState(false);
  const [numberOfPeopleModal, setNumberOfPeopleModal] = React.useState(false);
  const [linkListModal, setLinkListModal] = React.useState(false);
  const [comprehensiveOptionDetailsModal2, setComprehensiveOptionDetailsModal2] = React.useState(false);
  const hotelAreaCode = getHotelAreaCode(planSelectFormData);
  const hotelPlanAbortController = new AbortController();

  // モーダルのhandleを追加する

  //モーダル：宿泊施設を変更
  const handleHotelModal = (step: number) => {
    setStep(step)
    setStaySelectModal1(!staySelectModal1)
    setHotelCode("");
  }

  //プチモーダル：日程詳細
  const handleScheduleDetailModal = () => {
    setScheduleDetailModal(!scheduleDetailModal)
  }
  const onClickScheduleDetailModal = (activity: IActivity) => {
    if (activity !== undefined) {
      setSelectActivity({...activity});
      setScheduleDetailModal(!scheduleDetailModal)
    }
  }

  //プチモーダル：人数詳細
  const handleNumberOfPeopleModal = () => {
    setNumberOfPeopleModal(!numberOfPeopleModal)
  }

  //プチモーダル：ページ内遷移用
  const handleLinkListModal = () => {
    setLinkListModal(!linkListModal)
  }

  //モーダル：包括オプション設定2
  const handleComprehensiveOptionDetailsModal2 = () => {
    setStep(2)
    setComprehensiveOptionDetailsModal2(!comprehensiveOptionDetailsModal2)
  }

  const onClickComprehensiveOptionDetailsModal2 = (activityData: IActivity) => {
    if (activityData !== undefined) {
      setSelectActivity({...activityData})
      setStep(2)
      setComprehensiveOptionDetailsModal2(!comprehensiveOptionDetailsModal2)
    }
  }

  /**
   *  基本プラン更新
   * @param updateActivity
   */
  const handleCallbackOptionDetailsModal = (updateActivity: IActivity | undefined) => {
    if (updateActivity !== undefined) {
      const activityIndex = planSelectFormData.activity.findIndex((activityData) => {
        return activityData.plan_info.plan_code === updateActivity.plan_info.plan_code;
      })

      if (activityIndex >= 0) {
        planSelectFormData.activity[activityIndex] = updateActivity;
        updateData({...planSelectFormData});
      }
    }

    setStep(2)
    setComprehensiveOptionDetailsModal2(!comprehensiveOptionDetailsModal2)
  }
  //モーダル：日程確認
  const [ConnectingFlightModalState, setConnectingFlightModalState] = React.useState(false);
  const handleConnectingFlightModal = (airline:string, travelType:string, flight:FReservationFlight[] | undefined) => {
    if(flight) {
      setSelectedEntities(flight)
    }
    setConnectingFlightModalState(!ConnectingFlightModalState);
  };

  const handleConnectingDetailModalCallback = () => {
    setConnectingFlightModalState(!ConnectingFlightModalState);
  }

  // flight
  const [selectedEntities, setSelectedEntities] = React.useState<FReservationFlight[]>();
  const [flightModalState, setFlightModalState] = React.useState(false);
  const handleFlightModal = (airline:string, travelType:string, flight:FReservationFlight[] | undefined) => {
    // setUpdateIndex(index);
    devLog("OPEN")
    devLog("airline", airline)
    devLog("flight", flight)
    devLog("travelType", travelType)
    if(flight) {
      setFlightType({
        ...flightType,
        airline: airline,
        page: "confirm",
        currentNumbers: flight.map((f) => f.air_sub_no),
        action: travelType,
        flight: flight
      })
      setSelectedEntities(flight)
      setFlightModalState(!flightModalState);
    }
  };

  const flightModalCallback = () => {
    setFlightModalState(!flightModalState);      
  }

  //モーダル：チェックイン時間を変更する
  const [hotelCheckInTimeModalState, setHotelCheckInTimeModalState] = React.useState(false);
  const handleHotelCheckInTimeModal = (hotel: PlanSelectFromHotelType) => {
    setHotelCheckInInfoForModal({
      currentCheckInTime: hotel.checkTime ?? "15:00",
      checkInDate: hotel.checkIn,
      checkInStartTime: hotel.plan?.room_plan_detail.check_in_start ?? "12:00",
      checkInEndTime: hotel.plan?.room_plan_detail.check_in_end ?? "24:00",
    });

    setHotelCheckInTimeModalState(!hotelCheckInTimeModalState);
  };

  // チェックイン時間変更のモーダルでokがclickされた
  const handleChangeCheckInTimeInModal = (time: string, checkIn: string, checkInStart: string, checkInEnd: string) => {
    // validation
    const isValidTime = inDateTimeRange(time, checkIn, checkInStart, checkInEnd);

    if (!isValidTime) {
      alert(<Trans i18nKey={"チェックイン時間は${checkInStart}～${checkInEnd}の範囲内で入力してください。"} values={{checkInStart: checkInStart, checkInEnd: checkInEnd}} />);
      return;
    }

    changeCheckInTime(time, checkIn)

    setHotelCheckInTimeModalState(!hotelCheckInTimeModalState);
  };

  // チェックイン時間変更のモーダルのxもしくは枠外がclickされた
  const handleCloseInModal = () => {
    setHotelCheckInTimeModalState(!hotelCheckInTimeModalState);
  };

  //plan
  const [selectActivity, setSelectActivity] = React.useState<IActivity>();

  const [rangeDates, setRageDates] = React.useState<string[]>([]);
  const [planData, setPlanData] = React.useState<PlanSelectFormData>(planSelectFormData);
  const [planSchedule, setPlanSchedule] = React.useState<planSelectScheduleList[]>([]);

  const [airline, setAirline] = React.useState("ANA")

  // flight type
  const [flightType, setFlightType] = React.useState<FlightType>();

  // 区間追加（issue #3015 改訂3）
  // 「航空行程を追加」押下 → 日付ドロップダウン表示 → 日付クリック でモーダルを開く（日付は初期値として渡す）
  // モーダル内では往路→復路の2ステップ、または既存便の片方向編集を行う。
  const [additionalFlightModalOpen, setAdditionalFlightModalOpen] = React.useState<boolean>(false);
  const [additionalDatePickerOpen, setAdditionalDatePickerOpen] = React.useState<boolean>(false);
  // 日付ドロップダウンの参照: 枠外クリックで閉じるための outside-click 判定用
  const additionalDatePickerRef = React.useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!additionalDatePickerOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node | null;
      if (additionalDatePickerRef.current && target && !additionalDatePickerRef.current.contains(target)) {
        setAdditionalDatePickerOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [additionalDatePickerOpen]);
  /**
   * モーダルの呼び出し context:
   * - mode "add":  新規追加。モーダルが往復なら [inbound, outbound] の2件、片道なら1件を返す。order は次の空き番号
   *                initialDate には親で選んだ日付を渡す（モーダルの中日搭乗日 select に既定値として設定）
   * - mode "edit": 既存追加区間（order>=2）の片方向のみ編集。order と direction を指定して置換
   *   （メイン復路の出発空港変更＝オープンジョーは FlightModalApi の「変更する」に統合済み）
   */
  const [pendingAction, setPendingAction] = React.useState<
    | { mode: "add"; order: number; initialDate: string }
    /**
     * mode "add-return": 片道の追加区間に復路だけを足す（issue #3285 追加改修）。
     * 既存の往路は一切触らないのでモーダルは復路ステップから始まり、返るのは復路1件のみ。
     * order は既存区間のまま維持する（新しい区間としてカウントしない＝上限を消費しない）。
     */
    | {
        mode: "add-return";
        order: number;
        addReturnInitial: {
          date: string;               // 復路の既定日付（＝往路と同日）YYYYMMDD
          from: string;               // 往路の到着空港（＝復路の出発空港）
          to: string;                 // 往路の出発空港（＝復路の到着空港）
          inboundArrivalTime: string; // 往路の最終到着時刻 HHMM（同日 +2h ルールの基準）
        };
      }
    | {
        mode: "edit";
        order: number;
        direction: "inbound" | "outbound";
        date: string;
        // 編集対象が片道区間（対方向の無い order>=2）のとき true。モーダル側で③の判定を行わない
        editIsOneWay?: boolean;
        // M1: 編集モードで対方向便の情報を保持して +2h ルールを編集時も適用
        pairedFlight?: {
          date: string;
          arrivalTime?: string;
          departureTime?: string;
        };
        // 編集対象の現状の出発/到着空港 (モーダルの空港 select の初期選択に使う)
        editFrom?: string;
        editTo?: string;
        // 編集対象の現在の便の識別子。モーダルの自動検索後に選択状態を復元する（issue #3285）
        editCurrentFlightNumber?: string;
      }
    | null
  >(null);
  // 削除確認ダイアログの開閉と対象 order/日付
  const [dialogAdditionalFlightCancel, setDialogAdditionalFlightCancel] = React.useState<boolean>(false);
  const [cancelTargetOrder, setCancelTargetOrder] = React.useState<number>(0);
  const [cancelTargetDate, setCancelTargetDate] = React.useState<string>("");
  const isAdditionalFlightEnabled = planSelectFormData?.sellerProduct?.additionalFlightSettings?.status === "on";
  // 片道「区間追加」のリリースゲートは AdditionalFlightModal 側（src/config/featureFlags.ts）で判定する。
  // 復路の出発空港変更（オープンジョー）は FlightModalApi の「変更する」に統合済み（フラグ対象外）。
  
  useEffect(() => {
    const searchParams = planSelectFormData.searchParams;
    const dates = rangeDate(searchParams.start, searchParams.end);
    setRageDates([...dates]);
    const planSelectSchedule = getPlanSelectSchedule(planSelectFormData, dates);
    setPlanSchedule([...planSelectSchedule]);
    if (dates.length > 0 && scheduleListData.travelSchedule.length <= 0) {
      dates.forEach((date, index) => {
        const num = index + 1;
        const prefix = i18n.language === "en" ? `Day ${num} ` : `${num}日目 `;
        scheduleListData.travelSchedule.push({
          label: prefix + dateFormat(date, t("YYYY年MM月DD日（ddd）"), i18n.language),
          anchor: "#schedule" + num,
        });
      })
    }
    if(planData.flight && planData.flight.length > 0) {
      setAirline(planData.flight[0].airline)
    }
    
    updateScheduleListData(scheduleListData);

  },[planData])

  //-------------ここまでモーダルの処理------------------

  //ダイアログの処理
  const [dialogCancel, setDialogCancel] = React.useState(false);
  const [dialogChange, setDialogChange] = React.useState(false);

  //モーダル：キャンセル
  const handleDialogCancel = () => {
    setDialogCancel(!dialogCancel)
  }

  //モーダル：変更
  const handleDialogChange = () => {
    setDialogChange(!dialogChange)
  }

  /**
   * ホテル日程セクション
   */
  const [dialogHotelCancel, setDialogHotelCancel] = React.useState(false);
  const [hotelCancelDate, setHotelCancelDate] = React.useState("");
  const [hotelCancelCheckIn, setHotelCancelCheckIn] = React.useState("");
  const [hotelCancelHotelName, setHotelCancelHotelName] = React.useState("");
  const [isUpdateHotel, setIsUpdateHotel] = React.useState(true);
  const [updateHotelDate, setUpdateHotelDate] = React.useState("");
  const [hotelCode, setHotelCode] = React.useState<string>("");
  const [hotelIndex, setHotelIndex] = React.useState<number|undefined>();

  const [hotelCheckInInfoForModal, setHotelCheckInInfoForModal] = React.useState<{
    currentCheckInTime: string,
    checkInDate: string;
    checkInStartTime: string;
    checkInEndTime: string;
  }>({
    currentCheckInTime: "",
    checkInDate: "",
    checkInStartTime: "",
    checkInEndTime: "",
  });

  const getHotelIndex = (checkInDate: string, code: string) => {
    return planSelectFormData.hotel.findIndex((hotel) => {
      return hotel.checkIn === checkInDate && hotel.detail.hotel_code === code;
    })
  }

  const addHotelModal = (date: string) => {
    setUpdateHotelDate(date)
    setIsUpdateHotel(false)
    setHotelIndex(undefined);
    setStep(1)
    setStaySelectModal1(!staySelectModal1)
  }

  /**
   * 宿泊施設を変更するボタンクリック時
   * @param checkInDate 
   * @param code 
   */
  const changeSelectHotel = (checkInDate: string, code: string) => {
    const index = getHotelIndex(checkInDate, code);
    setHotelIndex(index);
    setUpdateHotelDate(checkInDate)
    setIsUpdateHotel(true)
    setStep(1)
    setStaySelectModal1(!staySelectModal1)
  }

  /**
   * 宿泊プランを変更するボタンクリック時
   * @param checkInDate 
   * @param code 
   */
  const handleUpdateStaySelectModal = (checkInDate: string, code: string) => {
    const index = getHotelIndex(checkInDate, code);
    setHotelIndex(index);
    setHotelCode(code);
    setUpdateHotelDate(checkInDate)
    setIsUpdateHotel(true)
    setStep(2)
    setStaySelectModal1(!staySelectModal1)
  }

  const clickCancelHotelDate = (date:string, checkIn:string, hotelName: string) => {
    setHotelCancelCheckIn(checkIn);
    setHotelCancelHotelName(hotelName);
    setDialogHotelCancel(!dialogHotelCancel)
    setHotelCancelDate(date);
  };

  /**
   * 指定した日付のホテルの日程を変更（チェックアウト日の変更）
   * @param date
   * @param checkIn
   */
  const cancelHotelDate = (date:string, checkIn:string) => {
    const updatePlanSelectHotel = planSelectFormData.hotel;
    const cancelHotelIndex = updatePlanSelectHotel.findIndex((hotel) => {
      return checkIn === hotel.checkIn;
    });
    const cancelHotel = updatePlanSelectHotel[cancelHotelIndex];
    if (cancelHotel.checkIn === date) {
      // 指定したホテル日程を削除
      updatePlanSelectHotel.splice(cancelHotelIndex, 1);
      planSelectFormData.hotel = updatePlanSelectHotel;
      setPlanData({...planSelectFormData});
      setDialogHotelCancel(!dialogHotelCancel)
      updatePlanSelectFormData({...planSelectFormData});
    } else {
      // 指定したホテルのチェックアウト日を変更
      updatePlanSelectHotel[cancelHotelIndex].checkOut = date;

      ( async () => {
        // 日程の変更により金額を再設定
        setIsSectionScheduleLoading(true);
        const cancelTarget = updatePlanSelectHotel[cancelHotelIndex];
        // state 更新レースで roomData が欠落することがあるため plan.room_code にフォールバック
        const roomPlanCode = cancelTarget.roomData?.room_code ?? cancelTarget.plan?.room_code ?? "";
        const planCode = cancelTarget.planCode ?? "";
        if (!cancelTarget.roomData?.room_code || !cancelTarget.planCode) {
          console.error("[cancelHotelDate] hotel state missing required fields", {
            hasRoomData: !!cancelTarget.roomData,
            hasRoomCodeInRoomData: !!cancelTarget.roomData?.room_code,
            hasRoomCodeInPlan: !!cancelTarget.plan?.room_code,
            hasPlanCode: !!cancelTarget.planCode,
            hasPlan: !!cancelTarget.plan,
            fallbackRoomCode: roomPlanCode,
            hotelIndex: cancelHotelIndex,
            hotelCode: cancelTarget.detail?.hotel_code,
            checkIn,
            date,
          });
        }
        const searchParams = {...planSelectFormData.searchParams};
        searchParams.checkin = checkIn;
        searchParams.checkout = date;
        const resultRoom = await hotelRoomSearch(hotelPlanAbortController, hotelAreaCode, searchParams, cancelTarget.detail.hotel_code, roomPlanCode, planCode, i18n.language);

        if (resultRoom && resultRoom.success) {
          if (updatePlanSelectHotel[cancelHotelIndex].plan) {
            const _plan = updatePlanSelectHotel[cancelHotelIndex].plan;
            if (_plan !== undefined) {
              updatePlanSelectHotel[cancelHotelIndex].plan = resultRoom.response
            }
          }
          updatePlanSelectHotel[cancelHotelIndex].total = resultRoom.response.room_plan_detail.total_price;
          planSelectFormData.hotel = updatePlanSelectHotel;
          setPlanData({...planSelectFormData});
          setDialogHotelCancel(!dialogHotelCancel)
          updatePlanSelectFormData({...planSelectFormData});
        } else {
          if (resultRoom?.ErrorInfo && ["E1009","E1010","E1011"].includes(resultRoom?.ErrorInfo.error_code)) {
            alert(t("本宿泊プランの連泊条件によりこの日程でのキャンセルはできません。宿泊施設の変更・キャンセルをご希望の場合は、宿泊プランの変更を行うかトップページへ戻り選択条件をご変更ください。"));
          } else {
            alert(t("プランの取得に失敗しました。"));
          }
        }
        setIsSectionScheduleLoading(false);
      })();
    }
    
  };

  const callbackDialogHotelCancel = () => {
    setDialogHotelCancel(!dialogHotelCancel)
  }

  const updateData = (updatePlanData: PlanSelectFormData) => {
    if (updatePlanData !== undefined) {
      setPlanData({...updatePlanData});
      updatePlanSelectFormData({...updatePlanData});
    }
  }


  /**
   * 指定した日付のホテルのチェックイン時間を変更
   * 
   * @param changedCheckInTime 
   * @param changedCheckIn 
   */
  const changeCheckInTime = (changedCheckInTime: string, changedCheckIn: string) => {
    const updatePlanSelectHotel = planSelectFormData.hotel;
    const changedHotelIndex = updatePlanSelectHotel.findIndex((hotel) => {
      return changedCheckIn === hotel.checkIn;
    });

    updatePlanSelectHotel[changedHotelIndex].checkTime = changedCheckInTime;

    planSelectFormData.hotel = updatePlanSelectHotel;
    updatePlanSelectFormData({...planSelectFormData});
    setPlanData({...planSelectFormData});
  };


  const [inboundFlight, setInboundFlight] = React.useState<PlanSelectFromFlightType>();
  const [outboundFlight, setOutboundFlight] = React.useState<PlanSelectFromFlightType>();
  const [currentFlights, setFlights] = React.useState<PlanSelectFromFlightType[]>([]);
  const [flightUpdateIndex, setUpdateIndex] = React.useState(0);

  // from -> to 往路
  // const handleInboundButtonClick = (airline: string) => {
  //  
  //   const iFlight = planData.flight.find(elm => {
  //     return elm.airline == airline && elm.action == "inbound"
  //   })
  //
  //   if(airline == 'ANA' && iFlight) {
  //     setFlightType({
  //       airline: 'ANA',
  //       currentNumbers: iFlight?.entity[0].air_sub_no,
  //       action: 'inbound'
  //     })
  //   }
  //
  //   if(airline == 'JAL' && iFlight) {
  //     setFlightType({
  //       airline: 'JAL',
  //       currentNumbers: iFlight?.entity[0].air_sub_no,
  //       action: 'inbound'
  //     })
  //   }
  //   setFlightModalState(!flightModalState);
  // }

  // to -> from 復路
  // const handleOutboundButtonClick = (airline: string) => {
  //
  //   const iFlight = planData.flight.find(elm => {
  //     return elm.airline == airline && elm.action == "outbound"
  //   })
  //
  //   if(airline == 'ANA' && iFlight) {
  //     setFlightType({
  //       airline: 'ANA',
  //       currentNumbers: iFlight?.entity[0].air_sub_no,
  //       action: 'outbound'
  //     })
  //   }
  //
  //   if(airline == 'JAL' && iFlight) {
  //     setFlightType({
  //       airline: 'JAL',
  //       currentNumbers: iFlight?.entity[0].air_sub_no,
  //       action: 'outbound'
  //     })
  //   }
  //   setFlightModalState(!flightModalState);
  // }

  // 利用空港の変更callback（いつか確認画面でも空港が変更できるようになるかも？）
  const changeAirportCallback = (airport: string) => {
    const code = getFlightCodeByLabel(airport);
    if(code) {
      // // TODO:いつかフュージョンする
      // setSearchParams({...searchParams,
      //   from: code, // need set code
      // });

      // // TODO:いつかフュージョンする
      // setPlanSelectFormData({
      //   ...planSelectFormData,
      //   searchParams: searchParams
      // })
    }
  }

  // 乗継便の到着時間を取得
  const getArrivalFlight = (flights:FReservationFlight[]): FReservationConnectionFlight | undefined  => {
    if(flights && flights.length > 0) {
      const lastFlight = lastCurrentFlight(flights[0].FReservationConnectionFlight);
      if (lastFlight.length > 0) {
        return lastFlight[0];
      }
    }
    return undefined;
  }

  // フライトの更新
  const flightUpdateDate = (airline:string, action:string, flights:FReservationFlightEntity[]) => {

    if(airline == undefined || action == undefined || flights == undefined) {
      devLog('undefined flight udpate data')
      return;
    }
    const planSelectFlights = planSelectFormData.flight;
    // H1 fix (issue #3015): メイン便の片方向のみを置換する。
    // 旧実装は `pf.action != action` で全 order の同方向便を削除していたため、
    // 追加区間（order>=2）の片方向が巻き込まれて消失するバグがあった。
    // 「メイン便（order=1 or 未設定）の対象 action」のみを除外し、追加区間はそのまま保持する。
    const isMain = (pf: PlanSelectFromFlightType) => !pf.order || pf.order === 1;
    const updateFlights = planSelectFlights.filter((pf) => !(isMain(pf) && pf.action === action))
    const newPlanSelectFlights = {
      airline: airline,
      entity: flights,
      action: action,
      connection: flights.length > 1,
      bookingClass: getFlightBookingClass(flights[0].class_code),
      useDate: flights ? flights[0].date : new Date(),
      selected: true,
      totalPrice: getFlightTotalPrice(flights, planSelectFormData.searchParams.roomDetail),
      order: 1, // メイン便として再設定
    } as PlanSelectFromFlightType
    updateFlights.push(newPlanSelectFlights)
    setFlightModalState(!flightModalState);
    let flightsPrice = 0;
    updateFlights.forEach((data) => {
      flightsPrice += data.totalPrice;
    })

    devLog("フライト金額")
    devLog(flightsPrice)

    setPlanData({
      ...planData,
      flight: updateFlights,
      flightTotal:flightsPrice,
    })
    updatePlanSelectFormData({
      ...planData,
      flight: updateFlights,
      flightTotal: flightsPrice,
    })
  }

  /**
   * 区間追加（issue #3015 改訂2 / 拡張: 片道対応 / #3285: 復路の後追い追加）:
   * モーダルから返却された SelectionEntry[] を flight[] へ反映する。
   *
   * - mode "add": 往復追加は entries.length === 2（[inbound, outbound]）、
   *               片道追加は entries.length === 1（[inbound]）。いずれも pendingAction.order を割り当てて append
   * - mode "edit": entries.length === 1 なら (order, direction) 一致のエントリを置換。
   *               entries.length === 2 は片道区間への復路後追い（issue #3285）で、
   *               [0] を往路として置換し [1] を同じ order の復路として append する。
   *               order を据え置くので追加区間の消費数は増えない（上限を消費しない）。
   */
  const handleAddAdditionalFlight = (
    entries: Array<{
      airline: string;
      from: string;
      to: string;
      date: string;
      flight: FReservationFlight[];
      direction: "inbound" | "outbound";
    }>,
  ) => {
    if (!pendingAction || entries.length === 0) return;

    // adult_fee / child_fee は数値化のみ。BE (getAirPrice) は OKA API から再取得した生値を使うため、
    // ここで min_fee フォールバックや child=adult 置換をすると FE 合計 > BE 合計の不一致が起きる。
    // 乗継料金は setByPersonFlightPrice / getAirPrice の両方が entity.FReservationConnectionFlight から
    // 別途加算するので、ここで adult/child に足し込むと FE 側だけ二重加算になる。
    const toPositive = (v: unknown): number => {
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? n : 0;
    };
    const normalizeEntity = (flight: FReservationFlight[]): FReservationFlight[] =>
      flight.map((f) => ({
        ...f,
        adult_fee: toPositive(f.adult_fee),
        child_fee: toPositive(f.child_fee),
      }));

    const buildPlanSelectFlight = (entry: typeof entries[number], order: number): PlanSelectFromFlightType => {
      const normalizedEntity = normalizeEntity(entry.flight);
      // useDate は YYYYMMDD 必須（reserveFlightDateFilter が dateFormat(date, "YYYYMMDD") と一致比較するため）
      const useDate = (normalizedEntity[0]?.date ?? entry.date).replace(/-/g, "");
      return {
        airline: entry.airline,
        entity: normalizedEntity,
        action: entry.direction,
        bookingClass: getFlightBookingClass(normalizedEntity[0]?.class_code ?? "Y"),
        connection: normalizedEntity.length > 1,
        useDate: useDate,
        selected: true,
        totalPrice: getFlightTotalPrice(normalizedEntity, planSelectFormData.searchParams.roomDetail),
        order: order,
      };
    };

    let updatedFlights: PlanSelectFromFlightType[];
    if (pendingAction.mode === "edit") {
      const { order, direction } = pendingAction;
      const replacement = buildPlanSelectFlight(entries[0], order);
      updatedFlights = planData.flight.map((f) =>
        ((f.order ?? 1) === order && f.action === direction) ? replacement : f,
      );
      // issue #3285: 片道区間に復路を後から足したケース。同じ order の便として append する。
      // order を据え置くので追加区間の数（＝上限の消費）は変わらない。
      // 同一 order・同一 action が二重にならないよう、既存の対方向便があれば置換に倒す（防御的）。
      if (entries.length > 1) {
        const added = entries.slice(1).map((e) => buildPlanSelectFlight(e, order));
        added.forEach((a) => {
          const existsIndex = updatedFlights.findIndex(
            (f) => (f.order ?? 1) === order && f.action === a.action,
          );
          if (existsIndex >= 0) updatedFlights[existsIndex] = a;
          else updatedFlights = [...updatedFlights, a];
        });
      }
    } else {
      // mode "add":        新規追加。往復=2件 / 片道=1件 を同じ order で push
      // mode "add-return": 既存片道区間への復路追加。復路1件を既存 order で push（order は増やさない）
      const { order } = pendingAction;
      const newOnes = entries.map((e) => buildPlanSelectFlight(e, order));
      // 同一 order・同一 action が二重にならないよう、既に同方向があれば置換に倒す（防御的）
      updatedFlights = [...planData.flight];
      newOnes.forEach((n) => {
        const existsIndex = updatedFlights.findIndex(
          (f) => (f.order ?? 1) === order && f.action === n.action,
        );
        if (existsIndex >= 0) updatedFlights[existsIndex] = n;
        else updatedFlights.push(n);
      });
    }

    const flightsPrice = updatedFlights.reduce((sum, f) => sum + (f.totalPrice ?? 0), 0);
    setPlanData({ ...planData, flight: updatedFlights, flightTotal: flightsPrice });
    updatePlanSelectFormData({ ...planData, flight: updatedFlights, flightTotal: flightsPrice });
    setPendingAction(null);
    setAdditionalFlightModalOpen(false);
  };

  /**
   * 区間追加で選択**できない**日付（issue #3285: 同日追加の解放）。
   *
   * メイン往復便（order=1 もしくは order 未指定）の搭乗日のみをブロックする。
   * それ以外の日は**既に追加区間が設定されていても選択可能**にした
   * （同じ日に2つ目の追加区間を置けるようにするため）。
   *
   * 旧実装は「フライトが設定済みの日付」を一律ブロックしていたため、
   * 1日1区間しか置けず、中日が1日しかない 2泊3日では実質1区間が上限だった。
   *
   * ⚠️ メイン便との時間重複ガードはこの日付ブロックのみで、時刻ベースの検証は無い。
   *    追加区間どうしが同日で時間的に重なるケースも現状は検証していない。
   */
  const blockedDatesForAdditional = new Set(
    planSchedule
      .filter((s) => (s.flight ?? []).some((f) => !f.order || f.order === 1))
      .map((s) => s.date),
  );

  // モーダルに渡す旅程の日付・選択不可日付（YYYYMMDD 形式）
  const tripDatesYmd = rangeDates.map((d) => d.replace(/-/g, ""));
  const usedDatesYmd = Array.from(blockedDatesForAdditional).map((d) => d.replace(/-/g, ""));

  /**
   * 区間追加の上限管理（issue #3015）。
   * - 旅程日数は searchParams.start/end から直接計算（初回 render 時 rangeDates が空でちらつくのを防ぐ）
   * - 算出失敗時は rangeDates.length をフォールバックに使う（M3: 日付形式が YYYY-MM-DD 以外でも保護）
   * - 上限: 3泊4日 → 1 往復 / 4泊5日以上 → 2 往復 / それ未満 → 0
   * - 現状の追加 round-trip 数 = 既存 flight の order 種類数のうち order >= 2 のもの
   * - 上限到達時はボタンを disable してユーザーに上限到達を伝える
   */
  const tripDaysCount = (() => {
    const start = planSelectFormData?.searchParams?.start;
    const end = planSelectFormData?.searchParams?.end;
    if (start && end) {
      const startMs = Date.parse(start);
      const endMs = Date.parse(end);
      if (!Number.isNaN(startMs) && !Number.isNaN(endMs) && endMs >= startMs) {
        return Math.floor((endMs - startMs) / 86400000) + 1;
      }
    }
    // フォールバック: 既に populate 済みの rangeDates が信頼できる
    return rangeDates.length;
  })();
  const maxAdditionalSegments = getMaxAdditionalFlightSegments(tripDaysCount);
  const currentAdditionalSegmentCount = (() => {
    const orders = new Set(
      (planData.flight ?? [])
        .map((f) => {
          const o = Number(f.order);
          // 不正な order（0/NaN/負）はメイン (=1) として扱う
          return Number.isFinite(o) && o >= 1 ? o : 1;
        })
        .filter((o) => o >= 2),
    );
    return orders.size;
  })();
  const isAdditionalSegmentLimitReached = currentAdditionalSegmentCount >= maxAdditionalSegments;

  /**
   * 追加区間（order>=2）の全レグをフラットに取り出したもの（issue #3285）。
   * 「order ごとのサマリ」と「日付ごとのサマリ」の両方をここから導出する（定義の二重化を防ぐ）。
   *
   * 乗継便の最終レグは `entity` 複数件 / `FReservationConnectionFlight` ネストの2形態があるので、
   * 到着空港・到着時刻はどちらの形態でも最終レグから取る。
   */
  const additionalFlightLegs = (() => {
    return (planData.flight ?? []).flatMap((f) => {
      const o = Number(f.order);
      if (!Number.isFinite(o) || o < 2) return [];
      if (!f.entity || f.entity.length === 0) return [];
      const head = f.entity[0];
      const lastArrapo =
        f.entity.length > 1
          ? f.entity[f.entity.length - 1].arrapo
          : (getArrivalFlight(f.entity)?.arrapo ?? head.arrapo);
      const lastArv =
        f.entity.length > 1
          ? f.entity[f.entity.length - 1].arv
          : (getArrivalFlight(f.entity)?.arv ?? head.arv);
      return [{
        order: o,
        direction: (f.action === "outbound" ? "outbound" : "inbound") as "inbound" | "outbound",
        useDate: (f.useDate ?? "").replace(/-/g, ""), // YYYYMMDD に正規化
        from: head.depapo,
        to: lastArrapo,
        dep: head.dep ?? "",
        arv: lastArv ?? "",
      }];
    });
  })();

  /**
   * 追加済みの区間サマリ（issue #3285）。
   * ドロップダウンの「追加済みの区間」ブロックで、変更/復路追加/削除の導線を出すために使う。
   *
   * order ごとに1行。往復なら往路・復路の2便、片道なら1便を legs に持つ。
   * 表示は `追加区間1 3/15 OKA→ISG（片道）` の形。
   */
  const additionalSegmentSummaries = (() => {
    const byOrder = new Map<number, typeof additionalFlightLegs>();
    additionalFlightLegs.forEach((leg) => {
      const legs = byOrder.get(leg.order) ?? [];
      legs.push(leg);
      byOrder.set(leg.order, legs);
    });
    return Array.from(byOrder.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([order, legs]) => ({
        order,
        // 往路 → 復路 の順に並べる
        legs: legs.sort((a, b) => (a.direction === b.direction ? 0 : a.direction === "inbound" ? -1 : 1)),
        // 表示ラベル（片道 / 往復）用。1レグなら方向に関わらず「片道」
        isOneWay: legs.length === 1,
        // 「復路を追加」の導線を出す判定。往路だけがある区間に限る。
        // 復路だけが残っている異常データに「復路を追加」を出すと同方向が2件できるため分けている
        canAddReturn: legs.length === 1 && legs[0].direction === "inbound",
      }));
  })();

  /**
   * 日付（YYYYMMDD）ごとの追加区間サマリ（issue #3285 追加改修）。
   * 「その日に既に追加区間が入っているか」を日付選択時に見せるために使う。
   * 同日に複数区間がある場合は出発時刻順に並べる。
   */
  const additionalSegmentsByDate: Record<string, typeof additionalFlightLegs> = (() => {
    const map: Record<string, typeof additionalFlightLegs> = {};
    additionalFlightLegs.forEach((leg) => {
      if (!leg.useDate) return;
      (map[leg.useDate] = map[leg.useDate] ?? []).push(leg);
    });
    Object.values(map).forEach((legs) => legs.sort((a, b) => a.dep.localeCompare(b.dep)));
    return map;
  })();

  /**
   * 「航空行程を追加」ボタン押下 → ドロップダウンを開閉する（issue #3285）。
   *
   * 上限到達時もボタンは活性のまま。ドロップダウン内の「新しく追加する日付」ブロックだけを
   * 非活性にして理由を明示する（グレーアウトだけだと追加済み区間の変更導線に辿り着けないため）。
   */
  const toggleAdditionalDatePicker = () => {
    setAdditionalDatePickerOpen((v) => !v);
  };

  /**
   * 日付ドロップダウンで日付がクリックされた時に、その日付を初期値としてモーダルを開く。
   * 上限到達時は何もしない（防御的、通常はボタン側で先にブロックされる）
   */
  const handlePickAdditionalDate = (date: string) => {
    if (isAdditionalSegmentLimitReached) return;
    if (blockedDatesForAdditional.has(date)) return; // メイン往復便の搭乗日は選択不可
    const existingOrders = (planData.flight ?? []).map((f) => f.order ?? 1);
    const nextOrder = Math.max(1, ...existingOrders) + 1;
    setPendingAction({
      mode: "add",
      order: nextOrder,
      initialDate: date.replace(/-/g, ""), // YYYY-MM-DD → YYYYMMDD
    });
    setAdditionalDatePickerOpen(false);
    setAdditionalFlightModalOpen(true);
  };

  /**
   * 片道の追加区間に「復路だけ」を足す（issue #3285 追加改修）。
   *
   * 既存の `変更する` → 往路を検索し直して選択 → `復路を選択する` の3ステップを、
   * 復路の選択画面に直行する1ステップに短縮する導線。往路は一切触らない。
   *
   * 復路の初期条件は既存の往路便から導出する:
   * - 出発/到着空港は往路の swap
   * - 日付は往路と同日を既定（往路日付より前は選べない）
   * - 同日の場合は往路の最終到着 +2時間以降の便のみ（モーダル側 outboundConstraint）
   */
  const handleAddReturnToAdditionalFlight = (order: number) => {
    const inbound = (planData.flight ?? []).find(
      (f) => (f.order ?? 1) === order && f.action !== "outbound",
    );
    if (!inbound || !inbound.entity || inbound.entity.length === 0) return;
    // 既に復路がある区間では呼ばない（防御的）
    const hasOutbound = (planData.flight ?? []).some(
      (f) => (f.order ?? 1) === order && f.action === "outbound",
    );
    if (hasOutbound) return;

    const head = inbound.entity[0];
    // 乗継便の最終レグ（entity 複数件／ネストの両形態に対応）
    const lastArrapo = inbound.entity.length > 1
      ? inbound.entity[inbound.entity.length - 1].arrapo
      : (getArrivalFlight(inbound.entity)?.arrapo ?? head.arrapo);
    const lastArv = inbound.entity.length > 1
      ? inbound.entity[inbound.entity.length - 1].arv
      : (getArrivalFlight(inbound.entity)?.arv ?? head.arv);

    setPendingAction({
      mode: "add-return",
      order,
      addReturnInitial: {
        date: (inbound.useDate ?? "").replace(/-/g, ""),
        from: lastArrapo,          // 往路の到着空港 → 復路の出発空港
        to: head.depapo,           // 往路の出発空港 → 復路の到着空港
        // arv が取れない便は dep にフォールバックして制約を完全には外さない（既存の安全側方針を踏襲）
        inboundArrivalTime: lastArv ?? head.dep ?? "",
      },
    });
    setAdditionalFlightModalOpen(true);
  };

  /**
   * 既存追加便の片方向のみ編集（issue #3015 改訂2）。
   * 同一 order の対方向は触らない（→ 編集中は片方向のみ）。
   *
   * M1: 対方向の便情報を pairedFlight として渡して、モーダル内で +2h ルールを編集時も適用。
   * - direction が outbound: paired = 同 order の inbound、その最終到着時刻 + 2h を編集対象の出発下限とする
   * - direction が inbound : paired = 同 order の outbound、その出発時刻 - 2h を編集対象の最終到着上限とする
   */
  const handleChangeAdditionalFlight = (
    order: number,
    direction: "inbound" | "outbound",
    useDate: string,
  ) => {
    // 同 order の対方向の便を探す（pair）
    const pair = (planData.flight ?? []).find(
      (f) => (f.order ?? 1) === order && f.action !== direction,
    );

    let pairedFlight: { date: string; arrivalTime?: string; departureTime?: string } | undefined;
    if (pair && pair.entity && pair.entity.length > 0) {
      const head = pair.entity[0];
      // 乗継便の場合は最終到着時刻を使う。乗継レグの持ち方は2形態ある:
      //  - entity が複数件（メイン便の旧形式）→ 最後の entity が最終レグ
      //  - entity 1件 + FReservationConnectionFlight にネスト（追加区間モーダル経由）→ ネストの最終レグ
      //    （旧判定 `connection && entity.length > 1` はネスト形態で第1レグの arv を返してしまい、
      //      +2h ルールが実際の最終到着より早い時刻を基準にするバグがあった）
      const lastArv = pair.entity.length > 1
        ? pair.entity[pair.entity.length - 1].arv
        : (getArrivalFlight(pair.entity)?.arv ?? head.arv);
      pairedFlight = {
        date: pair.useDate ?? "",
        // 対方向が inbound の場合（編集対象は outbound）→ 到着時刻
        arrivalTime: pair.action === "inbound" ? (lastArv ?? "") : undefined,
        // 対方向が outbound の場合（編集対象は inbound）→ 出発時刻
        departureTime: pair.action === "outbound" ? (head.dep ?? "") : undefined,
      };
    }

    // 編集対象の現状の出発・到着空港を取得（モーダルの空港 select の初期選択に使う）。
    // 乗継便の場合は depapo=最初の便の出発空港、arrapo=最終便の到着空港。
    const current = (planData.flight ?? []).find(
      (f) => (f.order ?? 1) === order && f.action === direction,
    );
    let editFrom: string | undefined;
    let editTo: string | undefined;
    if (current && current.entity && current.entity.length > 0) {
      editFrom = current.entity[0].depapo;
      // 乗継便の最終到着空港（pairedFlight の lastArv と同様に entity 複数件/ネストの両形態に対応）。
      // ネスト形態を entity[0].arrapo で拾うと第1レグ到着（中間空港）になってしまうため最終レグを辿る
      editTo = current.entity.length > 1
        ? current.entity[current.entity.length - 1].arrapo
        : (getArrivalFlight(current.entity)?.arrapo ?? current.entity[0].arrapo);
    }

    // 編集対象の現在の便の識別子。モーダルは開いた直後に自動検索し、この便を選択状態に復元する。
    // これが無いと「復路だけ足したい」場合でも往路を検索して選び直す必要がある（issue #3285）
    const editCurrentFlightNumber = current?.entity?.[0]
      ? createReserveFlightNumber(current.entity[0])
      : undefined;

    // 片道区間（対方向が無い order>=2）の編集では、モーダル側の③警告（滞在ハブ発でない）を出さない。
    // このフラグは同時に「確定エリアから復路を後追い追加できる区間か」の判定も兼ねる（issue #3285）
    const editIsOneWay = order >= 2 && !pair;

    setPendingAction({
      mode: "edit",
      order,
      direction,
      date: useDate,
      editIsOneWay,
      pairedFlight,
      editFrom,
      editTo,
      editCurrentFlightNumber,
    });
    setAdditionalFlightModalOpen(true);
  };

  /**
   * 区間追加で追加されたフライトを削除する（issue #3015）。
   * クリック時はまず確認ダイアログを開き、ダイアログの「はい」で実削除する。
   */
  const handleRemoveAdditionalFlight = (orderToRemove: number, useDate: string) => {
    if (orderToRemove <= 1) return;
    setCancelTargetOrder(orderToRemove);
    setCancelTargetDate(useDate);
    setDialogAdditionalFlightCancel(true);
  };

  /**
   * 削除確認ダイアログの「はい」時に呼ばれる本削除処理。
   * order を主キーに削除し、残った追加分の order を 2 から振り直して連番性を保つ。
   * メイン往復（order=1 もしくは未指定）は削除対象外。
   */
  const confirmRemoveAdditionalFlight = (orderToRemove: number) => {
    setDialogAdditionalFlightCancel(false);
    if (orderToRemove <= 1) return;
    const remaining = planData.flight.filter((f) => (f.order ?? 1) !== orderToRemove);
    // order を 2 から再採番（メインは触らない）
    const renumbered = remaining.map((f) => {
      const o = f.order ?? 1;
      if (o <= 1) return f;
      // 削除した order より大きい order を 1 ずつ詰める
      return o > orderToRemove ? { ...f, order: o - 1 } : f;
    });
    const flightsPrice = renumbered.reduce((sum, f) => sum + (f.totalPrice ?? 0), 0);
    setPlanData({ ...planData, flight: renumbered, flightTotal: flightsPrice });
    updatePlanSelectFormData({ ...planData, flight: renumbered, flightTotal: flightsPrice });
  };

  return (
    <>
      <section>
        <Backdrop className={classesForLoading.backdrop} open={isSectionScheduleLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <div className="wrap-content-900">
          {/* 旅行日程見出し + 区間追加ボタン（issue #3015 改訂3 / #3285 でドロップダウンを2ブロック化）
              押下でドロップダウンが開き、
                ① 追加済みの区間 … 変更（片道なら復路の後追い追加もここから）/ 削除
                ② 新しく追加する日付 … 日付を選ぶとその日付を初期値としてモーダルが開く
              上限到達時もボタンは活性のまま（②だけを非活性にして理由を明示する）。
              旧実装はボタン自体を disabled にしていたため、上限到達後は追加済み区間の
              変更導線に辿り着けず「削除して作り直す」しか無いことがユーザーに伝わらなかった。 */}
          <div style={{ position: "relative", zIndex: 50 }}>
            <h2 className="heading-2 mb-16 mb-14-md">{t("旅行日程")}</h2>
            {isAdditionalFlightEnabled && maxAdditionalSegments > 0 && (
              <div ref={additionalDatePickerRef} style={{ position: "absolute", top: 0, right: 0, zIndex: 51 }}>
                <button
                  type="button"
                  onClick={toggleAdditionalDatePicker}
                  title={isAdditionalSegmentLimitReached
                    ? (t("$max区間まで追加可能です（上限到達）", { max: maxAdditionalSegments }) ?? "")
                    : (t("$max区間まで追加可能", { max: maxAdditionalSegments }) ?? "")}
                  style={{
                    backgroundColor: "#1A3268",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 14px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span aria-hidden>✈</span>{t("航空行程を追加")}
                  <span style={{ fontSize: 11, fontWeight: "normal", marginLeft: 4 }}>
                    （{currentAdditionalSegmentCount} / {maxAdditionalSegments}）
                  </span>
                </button>
                {additionalDatePickerOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      marginTop: 4,
                      backgroundColor: "#fff",
                      border: "1px solid #d0dbef",
                      borderRadius: 4,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                      minWidth: 280,
                      maxHeight: 380,
                      overflowY: "auto",
                      zIndex: 1200,
                    }}
                  >
                    {/* ① 追加済みの区間: 変更 / 削除（issue #3285）。
                        片道区間の「変更」からモーダル内で復路を後追い追加できる */}
                    {additionalSegmentSummaries.length > 0 && (
                      <div style={{ borderBottom: "1px solid #e6ecf7" }}>
                        <p style={{ padding: "8px 14px 4px", fontSize: 11, fontWeight: "bold", color: "#7F95B7" }}>
                          {t("追加済みの区間")}
                        </p>
                        <ul style={{ listStyle: "none", padding: "0 0 8px", margin: 0 }}>
                          {additionalSegmentSummaries.map((seg) => (
                            <li key={"added-seg-" + seg.order} style={{ padding: "6px 14px" }}>
                              <p style={{ fontSize: 12, color: "#222", fontWeight: "bold", marginBottom: 4 }}>
                                {t("追加区間")}{seg.order - 1}
                                <span style={{ fontWeight: "normal", marginLeft: 6 }}>
                                  {/* 幅が限られるドロップダウン内なので空港名ではなく空港コードで表示する。
                                      useDate が欠けている場合は dayjs が "Invalid Date" を返すので日付を省く */}
                                  {seg.legs
                                    .map((leg) => {
                                      const label = `${leg.from}→${leg.to}`;
                                      return leg.useDate
                                        ? `${dateFormat(leg.useDate, "M/D", i18n.language)} ${label}`
                                        : label;
                                    })
                                    .join(" ／ ")}
                                </span>
                                <span style={{ fontWeight: "normal", marginLeft: 6, color: "#7F95B7" }}>
                                  （{seg.isOneWay ? t("片道") : t("往復")}）
                                </span>
                              </p>
                              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                {seg.legs.map((leg) => (
                                  <button
                                    key={"added-seg-edit-" + seg.order + "-" + leg.direction}
                                    type="button"
                                    className="button-text-link fz-12"
                                    onClick={() => {
                                      setAdditionalDatePickerOpen(false);
                                      handleChangeAdditionalFlight(seg.order, leg.direction, leg.useDate);
                                    }}
                                  >
                                    {leg.direction === "inbound" ? t("往路を変更") : t("復路を変更")}
                                  </button>
                                ))}
                                {/* 往路だけの区間には「復路を追加」。押下で復路の選択画面に直行する
                                    （往路を選び直す必要が無い / issue #3285 追加改修） */}
                                {seg.canAddReturn && (
                                  <button
                                    type="button"
                                    className="button-text-link fz-12"
                                    style={{ color: "#F85400" }}
                                    onClick={() => {
                                      setAdditionalDatePickerOpen(false);
                                      handleAddReturnToAdditionalFlight(seg.order);
                                    }}
                                  >
                                    {t("復路を追加")}
                                  </button>
                                )}
                                <button
                                  type="button"
                                  className="button-text-link fz-12"
                                  onClick={() => {
                                    setAdditionalDatePickerOpen(false);
                                    handleRemoveAdditionalFlight(seg.order, seg.legs[0]?.useDate ?? "");
                                  }}
                                >
                                  {t("削除")}
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* ② 新しく追加する日付。
                        上限到達時も**日付リスト自体は表示したまま**全日付をグレーアウトして操作不可にする。
                        リストごと消すと「どの日に何が入っているか」が確認できなくなるため（issue #3285 追加改修）。 */}
                    <div>
                      <p style={{ padding: "8px 14px 4px", fontSize: 11, fontWeight: "bold", color: "#7F95B7" }}>
                        {t("新しく追加する日付")}
                      </p>
                      {isAdditionalSegmentLimitReached && (
                        <p style={{ padding: "4px 14px 8px", fontSize: 12, color: "#7F95B7" }}>
                          {t("これ以上区間を追加できません（上限 $max 区間）", { max: maxAdditionalSegments })}
                        </p>
                      )}
                      <ul style={{ listStyle: "none", padding: "0 0 4px", margin: 0 }}>
                          {rangeDates.map((d) => {
                            // メイン往復便の搭乗日のみ選択不可。追加区間が既にある日は選べる（issue #3285）
                            const isMainFlightDate = blockedDatesForAdditional.has(d);
                            // 上限到達時は全日付を選択不可にする（リストは表示したまま）
                            const isDisabled = isMainFlightDate || isAdditionalSegmentLimitReached;
                            // その日に既に入っている追加区間（issue #3285 追加改修）
                            const daySegments = additionalSegmentsByDate[d.replace(/-/g, "")] ?? [];
                            return (
                              <li
                                key={d}
                                onClick={() => handlePickAdditionalDate(d)}
                                style={{
                                  padding: "8px 14px",
                                  cursor: isDisabled ? "not-allowed" : "pointer",
                                  color: isDisabled ? "#aaa" : "#222",
                                  backgroundColor: isDisabled ? "#f5f5f5" : "transparent",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                aria-disabled={isDisabled}
                              >
                                <span style={{ flex: 1 }}>
                                  {dateFormat(d, t("YYYY/MM/DD（ddd）"), i18n.language)}

                                  {/* ▼▼▼ A案: 追加区間が設定済みであることをラベルで示す ▼▼▼
                                      （B案と二択。不要な方をこのブロックごと削除してください） */}
                                  {daySegments.length > 0 && (
                                    <span
                                      style={{
                                        display: "inline-block",
                                        marginLeft: 8,
                                        padding: "1px 6px",
                                        borderRadius: 3,
                                        backgroundColor: "#1A3268",
                                        color: "#fff",
                                        fontSize: 10,
                                        fontWeight: "bold",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {t("追加区間")}
                                      {Array.from(new Set(daySegments.map((s) => s.order - 1))).join("・")}
                                      {" "}
                                      {t("設定済み")}
                                    </span>
                                  )}
                                  {/* ▲▲▲ A案ここまで ▲▲▲ */}

                                  {/* ▼▼▼ B案: 日付の下にフライトスケジュールの詳細を表示 ▼▼▼
                                      （A案と二択。不要な方をこのブロックごと削除してください） */}
                                  {daySegments.map((s, sIdx) => (
                                    <span
                                      key={"day-seg-" + d + "-" + sIdx}
                                      style={{ display: "block", marginTop: 2, fontSize: 11, color: "#7F95B7" }}
                                    >
                                      └ {t("追加区間")}{s.order - 1}
                                      {getFlightTime(s.dep)} {s.from} → {s.to} {getFlightTime(s.arv)}
                                    </span>
                                  ))}
                                  {/* ▲▲▲ B案ここまで ▲▲▲ */}
                                </span>
                                {isMainFlightDate ? (
                                  <span style={{ fontSize: 11, flexShrink: 0 }}>（{t("メイン往復")}）</span>
                                ) : isDisabled ? (
                                  // 上限到達によるグレーアウト。押せないので「›」は出さない
                                  <span style={{ fontSize: 11, flexShrink: 0 }}>（{t("上限到達")}）</span>
                                ) : (
                                  <span aria-hidden style={{ fontSize: 12, flexShrink: 0 }}>›</span>
                                )}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="sticky-top-list">
            {planSchedule.length > 0?
              <>
                {planSchedule.map((schedule, sIndex) => (
                  <Fragment key={sIndex}>
                    <div id={"schedule"+(sIndex + 1)} className="sticky-top-list-item">
                      <Accordion className="accordion-schedule" expanded={true}>
                        <AccordionSummary
                          className="accordion-schedule-heading"
                          onClick={handleLinkListModal}
                        >
                          <span className="label-navy mr-10"><Trans i18nKey={"${num}日目"} values={{num: sIndex+1}} /></span>
                          {dateFormat(schedule.date, t("YYYY年MM月DD日（ddd）"), i18n.language)}
                        </AccordionSummary>
                        <AccordionDetails className="accordion-schedule-content">
                          <div className="box-separator_bottom-border_small w-100per">
                            {schedule.flight !== undefined  && (
                              <>
                                {schedule.flight.map((flight, fIndex) => (
                                  <Fragment key={fIndex}>
                                    {/* フライト */}
                                    <div className="box-separator_bottom-border_small-item">
                                      {/* 中日追加区間ラベル（issue #3015）。フライト見出しの上に1行で配置 */}
                                      {flight.order && flight.order > 1 && (
                                        <p className="mb-8">
                                          <span style={{ display: "inline-block", padding: "2px 8px", backgroundColor: "#1A3268", color: "#fff", borderRadius: 4, fontSize: 12, fontWeight: "bold" }}>
                                            {t("追加区間")}{flight.order - 1}
                                          </span>
                                        </p>
                                      )}
                                      <p className="mb-16 fz-18 fz-20-md fw-b">
                                        <i className="icon-flight-circle mr-8 fz-26"></i>
                                        {t("フライト")}
                                      </p>
                                      <div className="box-flight">
                                        <div className="box-flight-seat">
                                          <div className="box-flight-seat-label">

                                            { isConnection(flight.entity[0]) ?
                                              <span className="label-dark_orange mr-10 mb-16-md">
                                                  {t("乗継便")}
                                                </span> : ""
                                            }
                                          </div>
                                          <div className="box-flight-seat-detail">
                                            <p>{t(getFlightClassLabel(flight.entity[0].class_code))} {getFlightPeopleConfirmLabel(planSelectFormData.searchParams.roomDetail, i18n.language)}</p>
                                            <ul className="list-note light-gray">
                                              <li key={"section-schedule-seat-detail-note"} className="fz-10 fz-12-md">{t("12歳以上は大人席となります。")}</li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="box-flight-time">
                                          <div className="box-flight-time-airline">
                                            <div className="mr-10">
                                              <p className="box-flight-time-airline-logo">
                                                <img
                                                    src={ getAirLineLogo(flight.airline, flight.entity[0].air_code, flight.entity[0].air_sub_no) }
                                                    alt={`フライト：${flight.airline === "JAL" ?
                                                                      getAirLineNameInJalGroup(flight.entity[0].air_code, flight.entity[0].air_sub_no) 
                                                                      : getAirLineNameInAnaGroup(flight.entity[0].air_code)}`}
                                                />
                                              </p>
                                              <p className="box-flight-time-airline-label">
                                                { getFlightNumberForDisplay(flight.airline, flight.entity[0].air_code, flight.entity[0].air_sub_no, i18n.language) }
                                              </p>
                                            </div>

                                            <div>
                                              <ul className="box-flight-time-airline-time">
                                                <li key={"flight-time-airline-time-item-1"} className="box-flight-time-airline-time-item">
                                                  <p className="box-flight-time-airline-time-item-heading">
                                                    {getFlightTime(flight.entity[0].dep)}
                                                  </p>
                                                  <p className="box-flight-time-airline-time-item-label">
                                                    {t(`Airport.${getFlightCodeLabel(flight.entity[0].depapo) ?? ""}`)}
                                                  </p>
                                                </li>
                                                <li  key={"flight-time-airline-time-item-2"} className="box-flight-time-airline-time-item">
                                                  <p className="box-flight-time-airline-time-item-heading">
                                                    {/* { flight.entity[0].connection ? getFlightTime(getArrivalFlight(flight.action)?.arv) : getFlightTime(flight.entity[0].arv) } */}
                                                    { isConnection(flight.entity[0]) ? getFlightTime(getArrivalFlight(flight.entity)?.arv) : getFlightTime(flight.entity[0].arv) }
                                                  </p>
                                                  <p className="box-flight-time-airline-time-item-label">
                                                    {/* { flight.entity[0].connection ? getFlightCodeLabel(getArrivalFlight(flight.action)?.arrapo) : getFlightCodeLabel(flight.entity[0].arrapo) } */}
                                                    { isConnection(flight.entity[0]) ? t(`Airport.${getFlightCodeLabel(getArrivalFlight(flight.entity)?.arrapo) ?? ""}`) : t(`Airport.${getFlightCodeLabel(flight.entity[0].arrapo) ?? ""}`) }
                                                  </p>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="box-flight-detail">
                                          { isConnection(flight.entity[0]) ?
                                            <p className="box-flight-detail-change">
                                              <button
                                                onClick={() => handleConnectingFlightModal(flight.airline, flight.action, flight.entity)}
                                                className="button-clear-blue fz-13 fw-b"
                                              >
                                                {t("乗継便詳細を見る")}
                                              </button>
                                            </p> : ""
                                          }
                                          <p className="box-flight-detail-button">
                                            {/* メイン往復は既存「変更する」、
                                                追加区間（order>1）は「変更する」+「削除する」を並べる（issue #3015） */}
                                            {flight.order && flight.order > 1 ? (
                                              <span style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "center" }}>
                                                {/* 編集はその便（往路 or 復路）のみ。同一 order の対方向は触らない */}
                                                <button
                                                  className="button-border-medium w-100per"
                                                  onClick={() => handleChangeAdditionalFlight(
                                                    flight.order as number,
                                                    (flight.action === "outbound" ? "outbound" : "inbound"),
                                                    flight.useDate ?? "",
                                                  )}
                                                >
                                                  {t("変更する")}
                                                </button>
                                                {/* 削除はホテルキャンセルと同じテキストリンク調。order 内の両方向が同時に消える */}
                                                <button
                                                  className="button-text-link fz-12"
                                                  onClick={() => handleRemoveAdditionalFlight(flight.order as number, flight.useDate ?? "")}
                                                >
                                                  <i className="icon-bad-circle-black mr-5"></i>
                                                  {t("この追加区間を削除")}
                                                </button>
                                              </span>
                                            ) : (
                                              <span style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "center" }}>
                                                {/* メイン便の変更。復路の出発空港（島側）変更＝オープンジョーも
                                                    このモーダル内で行えるよう統合済み（issue #3015 拡張）。
                                                    旧「出発空港を変更する」別導線は撤去 */}
                                                <button
                                                  className="button-border-medium w-100per"
                                                  onClick={() => handleFlightModal(flight.airline, flight.action, flight.entity)}
                                                >
                                                  {t("変更する")}
                                                </button>
                                              </span>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Fragment>
                                ))}
                              </>
                            )}
                            {schedule.activity !== undefined && schedule.activity.length > 0 ?
                              <>
                                {/* 基本プラン */}
                                <div className="box-separator_bottom-border_small-item">
                                  <p className="mb-16 fz-18 fz-20-md fw-b">
                                    <i className="icon-flag-circle mr-5 fz-26"></i>
                                    {t("基本プラン")}
                                  </p>
                                  <div className="box-plan-content">
                                    {schedule.activity.map((activity, aIndex) => (
                                      <div key={aIndex} className="box-plan-content-item">
                                        <div className="box-plan-content-item-description">
                                          <div className="box-plan-content-item-description-thumbnail">
                                            <img
                                              src={activity.plan_info.image_list[0].image_url}
                                              alt=""
                                            />
                                          </div>
                                          <div className="box-plan-content-item-description-text">
                                            <p className="mb-5">
                                              <span className="label-orange">
                                                <i className="icon-flag-orange mr-5"></i>
                                                {t("プラン")}{aIndex + 1}
                                              </span>
                                            </p>
                                            <p>
                                              {activity.plan_info.plan_name}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="box-plan-content-item-status">
                                          <div className="box-plan-content-item-status-inner w-100per">
                                            <p className="mb-10-md ta-c">
                                              <button
                                                onClick={() => onClickScheduleDetailModal(activity)}
                                                className="button-clear-blue fz-13 fw-b"
                                              >
                                                {t("日程詳細を見る")}
                                              </button>
                                            </p>
                                            <p>
                                              <button
                                                className="button-border-medium w-100per"
                                                onClick={() => onClickComprehensiveOptionDetailsModal2(activity)}
                                              >
                                                {t("変更する")}
                                              </button>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </>:<></>
                            }

                            {schedule.hotel !== undefined && schedule.hotel.length > 0 ?
                              <>
                                {/* 宿泊 */}
                                <div className="box-separator_bottom-border_small-item">
                                  <p className="mb-20 mb-14-md fz-18 fz-20-md fw-b">
                                    <i className="icon-sleep-circle mr-5 fz-32"></i>{t("宿泊")}
                                  </p>
                                  {schedule.hotel.map((hotel, hIndex) => (
                                    <div key={hIndex} className="box-stay-item">
                                      <div className="box-stay-item-thumbnail small">
                                        <img
                                          src={hotel.detail.image_l_url}
                                          alt=""
                                        />
                                        {isOkinawaSaihakkenLabel(planSelectFormData, hotel.detail.hotel_code) && (
                                          <span className={"label-travel-support"}>全国割対象</span>
                                        )}
                                      </div>
                                      <div className="box-stay-item-content">
                                        <div className="box-stay-item-content-area">
                                          {hotel.detail.sub_area_name !== undefined ? (
                                            <ul className="box-stay-item-content-area-list">
                                              <li key={"tay-item-content-area-list-" + hIndex} className="box-stay-item-content-area-list-item">{hotel.detail.sub_area_name}</li>
                                            </ul>
                                          ) : (<></>)}
                                        </div>
                                        <div className="box-stay-item-content-heading">
                                          {hotel.detail.hotel_name}
                                        </div>
                                        <div className="box-stay-item-content-label">
                                          <ul className="box-stay-item-content-label-list">
                                            {hotel.detail.hotel_type_list?.map((list, index) => (
                                              <li key={"hotel-type-list-" + index} className="box-stay-item-content-label-list-item">{t(getHotelTypeLabel(list.hotel_type_code))}</li>
                                            ))}
                                          </ul>
                                        </div>
                                        {/*pc用*/}
                                        <div className="box-stay-item-content-option">
                                          {schedule.date === hotel.checkIn?
                                            <>
                                              <dl className="box-stay-item-content-option-dl">
                                                <dt className="box-stay-item-content-option-dl-dt">
                                                  {t("チェックイン")}
                                                </dt>
                                                <dd className="box-stay-item-content-option-dl-dd">
                                                  {hotel.checkTime}
                                                  <button
                                                    onClick={() => handleHotelCheckInTimeModal(hotel)}
                                                    className="button-clear-blue fz-10 fz-12-md"
                                                  >
                                                    {t("チェックイン時間を変更する")}
                                                  </button>
                                                </dd>
                                              </dl>
                                            </>:<></>
                                          }
                                          <dl className="box-stay-item-content-option-dl">
                                            <dt className="box-stay-item-content-option-dl-dt">
                                              {t("客室")}
                                            </dt>
                                            <dd className="box-stay-item-content-option-dl-dd">
                                              {hotel.roomData?.room_name}
                                            </dd>
                                          </dl>
                                          <dl className="box-stay-item-content-option-dl">
                                            <dt className="box-stay-item-content-option-dl-dt">
                                              {t("宿泊プラン")}
                                            </dt>
                                            <dd className="box-stay-item-content-option-dl-dd">
                                              {hotel.plan?.room_plan_detail.plan_name}
                                            </dd>
                                          </dl>
                                        </div>
                                      </div>
                                      <div className="box-stay-item-optipn">
                                        {/*sp用*/}
                                        <div className="box-stay-item-content-option">
                                          {schedule.date === hotel.checkIn?
                                            <>
                                              <dl className="box-stay-item-content-option-dl">
                                                <dt className="box-stay-item-content-option-dl-dt">
                                                  {t("チェックイン")}
                                                </dt>
                                                <dd className="box-stay-item-content-option-dl-dd">
                                                  {hotel.checkTime}
                                                  <button
                                                    onClick={() => handleHotelCheckInTimeModal(hotel)}
                                                    className="button-clear-blue fz-10 fz-12-md"
                                                  >
                                                    {t("チェックイン時間を変更する")}
                                                  </button>
                                                </dd>
                                              </dl>
                                            </>:<></>
                                          }
                                          <dl className="box-stay-item-content-option-dl">
                                            <dt className="box-stay-item-content-option-dl-dt">
                                              {t("客室")}
                                            </dt>
                                            <dd className="box-stay-item-content-option-dl-dd">
                                              {hotel.roomData?.room_name}
                                            </dd>
                                          </dl>
                                          <dl className="box-stay-item-content-option-dl">
                                            <dt className="box-stay-item-content-option-dl-dt">
                                              {t("宿泊プラン")}
                                            </dt>
                                            <dd className="box-stay-item-content-option-dl-dd">
                                              {hotel.plan?.room_plan_detail.plan_name}
                                            </dd>
                                          </dl>
                                        </div>
                                      </div>
                                      <div className="box-stay-item-detail large padding-large-bottom-medium">
                                        <div className="w-100per">
                                          <p className="mb-12-md mb-16 ta-c">
                                            <button
                                              onClick={handleNumberOfPeopleModal}
                                              className="button-clear-blue fz-13 fw-b"
                                            >
                                              {t("人数内訳を見る")}
                                            </button>
                                          </p>
                                          {hotelChangeDisabled(schedule.date, hotel.checkIn) ?
                                            <>
                                              {planSelectFormData.isHotels && (
                                                <>
                                                  <p className="mb-16 mb-8-md">
                                                    <button className="button-border-medium disable w-100per">
                                                      {t("宿泊施設を変更する")}
                                                    </button>
                                                  </p>
                                                </>
                                              )}
                                              <p>
                                                <button className="button-border-medium disable w-100per">
                                                  {t("宿泊プランを変更する")}
                                                </button>
                                              </p>
                                              <p className="fz-12 c-blue_gray mt-20 mt-12-md ws-nw ta-c lh-1"><Trans i18nKey={"変更は初泊日のみで行なえます。"} components={{span: <span className='c-red fw-b'/>}} /></p>
                                            </>
                                            :
                                            <>
                                              {planSelectFormData.isHotels && (
                                                <>
                                                  <p className="mb-16 mb-8-md">
                                                    <button
                                                      onClick={() => changeSelectHotel(hotel.checkIn, hotel.detail.hotel_code)}
                                                      className="button-border-medium w-100per"
                                                    >
                                                      {t("宿泊施設を変更する")}
                                                    </button>
                                                  </p>
                                                </>
                                              )}
                                              <p>
                                                <button
                                                  onClick={() => handleUpdateStaySelectModal(hotel.checkIn, hotel.detail.hotel_code)}
                                                  className="button-border-medium w-100per"
                                                >
                                                  {t("宿泊プランを変更する")}
                                                </button>
                                              </p>
                                            </>
                                          }
                                        </div>
                                      </div>
                                      {hotelCancelDisabled(schedule.date, hotel.checkIn, planSelectFormData.hotel)?
                                        <>
                                          <div className="box-stay-item-cancel">
                                            <p>
                                              <button
                                                className="button-text-link fz-12"
                                                onClick={() => clickCancelHotelDate(schedule.date, hotel.checkIn, hotel.detail.hotel_name)}
                                              >
                                                <i className="icon-bad-circle-black mr-5"></i>
                                                {t("この日程以降の宿泊をキャンセル")}
                                              </button>
                                            </p>
                                          </div>
                                        </>:<></>
                                      }
                                    </div>
                                  ))}
                                </div>
                              </>
                              :schedule.date !== planSelectFormData.searchParams.end?
                              <>
                                {/* ホテル */}
                                <div className="box-separator_bottom-border_small-item">
                                  <p className="mb-20 mb-14-md fz-18 fz-20-md fw-b">
                                    <i className="icon-sleep-circle mr-5 fz-32"></i>{t("宿泊")}
                                  </p>
                                  <div className="box-light-gray small">
                                    <button
                                      className="button-medium-orange w-100per"
                                      onClick={() => addHotelModal(schedule.date)}
                                    >
                                      {t("ホテルを追加する")}
                                    </button>
                                  </div>
                                </div>
                              </>:<></>
                            }
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </Fragment>
                ))}

              </>:<></>
            }

          </div>
        </div>
      </section>

      {/* ここに作成したモーダルを追加する */}
      {/* モーダル：宿泊施設・宿泊プラン */}
      {staySelectModal1 && (
        <StaySelectModal
          updateHotelIndex={hotelIndex}
          date={updateHotelDate}
          isUpdate={isUpdateHotel}
          selectHotelCode={hotelCode}
          updateSelectHotel={updateData}
          planSelectFormData={planSelectFormData}
          stepHandler={stepHandle}
          defaultStep={step}
          isShow={staySelectModal1}
          callback={() => handleHotelModal(1)}
        />
      )}

      {/* プチモーダル：基本プラン 日程詳細 */}
      <ScheduleDetailModal isShow={scheduleDetailModal} callback={handleScheduleDetailModal} handleSelectedActivity={(activityData) => {onClickComprehensiveOptionDetailsModal2(activityData); handleScheduleDetailModal();}} activity={selectActivity} />
      {/* モーダル：基本プラン */}
      <ComprehensiveOptionDetailsModal stepHandler={stepHandle} defaultStep={step} isShow={comprehensiveOptionDetailsModal2} callback={handleCallbackOptionDetailsModal} activity={selectActivity} planSelectFormData={planSelectFormData} />

      {/* プチモーダル：人数詳細 */}
      <NumberOfPeopleModal planSelectFormData={planSelectFormData} isShow={numberOfPeopleModal} callback={handleNumberOfPeopleModal} />

      {/* リンクリスト */}
      <LinkListModal isShow={linkListModal} scheduleListModalData={scheduleListData} callback={handleLinkListModal} />

      {/* モーダル：フライト選択 */}
      {/* <FlightModal isShow={flightModalState} callback={handleFlightModal} /> */}
      <FlightModalApi planSelectFormData={planSelectFormData} profitRate={planSelectFormData.planData?.sellerIndo.profitRate?? "0"} pageRef="schedule" changeFlightCallback={flightUpdateDate} search={planSelectFormData.searchParams} currentFlights={flightType} changeAirportCallback={changeAirportCallback} isShow={flightModalState} callback={flightModalCallback} />

      {/* モーダル：区間追加（issue #3015 改訂3）。日付ドロップダウンで選んだ日付をデフォルト値で開く */}
      {pendingAction && (
        <AdditionalFlightModal
          isShow={additionalFlightModalOpen}
          mode={pendingAction.mode === "edit" ? "edit" : pendingAction.mode === "add-return" ? "add-return" : "round-trip"}
          airline={airline}
          tripDates={tripDatesYmd}
          usedDates={usedDatesYmd}
          additionalSegmentsByDate={additionalSegmentsByDate}
          // 操作対象の区間自身を「この日に設定済み」と出さないよう除外する（issue #3285 追加改修）。
          // mode "add" の order はまだ存在しない採番なので、渡しても何も除外されない
          excludeSegmentOrder={pendingAction.order}
          addReturnInitial={pendingAction.mode === "add-return" ? pendingAction.addReturnInitial : undefined}
          initialInboundDate={pendingAction.mode === "add" ? pendingAction.initialDate : undefined}
          editDirection={pendingAction.mode === "edit" ? pendingAction.direction : undefined}
          editDate={pendingAction.mode === "edit" ? pendingAction.date : undefined}
          editIsOneWay={pendingAction.mode === "edit" ? pendingAction.editIsOneWay : undefined}
          pairedFlight={pendingAction.mode === "edit" ? pendingAction.pairedFlight : undefined}
          editFrom={pendingAction.mode === "edit" ? pendingAction.editFrom : undefined}
          editTo={pendingAction.mode === "edit" ? pendingAction.editTo : undefined}
          editCurrentFlightNumber={pendingAction.mode === "edit" ? pendingAction.editCurrentFlightNumber : undefined}
          defaultFrom={planSelectFormData?.sellerProduct?.useAirport?.arrival || "OKA"}
          planSelectFormData={planSelectFormData}
          callback={() => {
            // 閉じる時に pendingAction もクリア
            setAdditionalFlightModalOpen(false);
            setPendingAction(null);
          }}
          onConfirm={handleAddAdditionalFlight}
        />
      )}

      {/* ダイアログ：追加区間の削除確認（issue #3015） */}
      <DialogAdditionalFlightCancel
        isShow={dialogAdditionalFlightCancel}
        date={cancelTargetDate}
        order={cancelTargetOrder}
        callback={() => setDialogAdditionalFlightCancel(false)}
        callbackConfirm={confirmRemoveAdditionalFlight}
      />
      {/* モーダル：乗継便確認 */}
      <ConnectingFlightModal flights={selectedEntities} airline={airline} isShow={ConnectingFlightModalState} callback={handleConnectingDetailModalCallback} />

      {/* モーダル：チェックイン時間の変更 */}
      <HotelCheckInTimeModal
        hotelInfo={hotelCheckInInfoForModal}
        isShow={hotelCheckInTimeModalState}
        handleChangeCheckInTime={handleChangeCheckInTimeInModal}
        callback={handleCloseInModal}
      />

      {/* ダイアログ： キャンセル */}
      <DialogCancel isShow={dialogCancel} callback={handleDialogCancel} />
      <DialogHotelCancel date={hotelCancelDate} checkIn={hotelCancelCheckIn} hotelName={hotelCancelHotelName} isShow={dialogHotelCancel} callback={callbackDialogHotelCancel} callbackHotelCancel={cancelHotelDate} />
    </>
  );
};

export default SectionSchedule;
